import { switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EmployeeInfoService } from '../../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { EmployeeService } from './../../../../pages/employee/services/employee.service';
import { NgForm } from '@angular/forms';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-expense-bulk-update-modal',
  templateUrl: './expense-bulk-update-modal.component.html',
  styleUrls: ['./expense-bulk-update-modal.component.css']
})
export class ExpenseBulkUpdateModalComponent implements OnInit {
  @Input() data: any;
  @Input() selectedEmployee: any;
  @ViewChild('typeFields', { static: false }) typeFields: NgForm;
  portalSettings: any;
  orderByPipe: any;
  format: string;
  exDisableLineRequireFields: boolean;
  formData: { [key: string]: any } = {};
  earnCodeList: any[] = [];
  ExpenseItemID: any;
  newFiles: any[];
  savedFiles: any[];
  fieldsName: any[];
  groupedFields: any[];
  attachmentList: any[];
  itemDetails: { [key: string]: any } = {};
  isPR: boolean;
  lookupValues: { [key: string]: any } = {};
  lookupLoaded: { [key: string]: any } = {};
  itemDetailsCheck: { [key: string]: any } = {};
  lineTypeList: any[];
  employeeInfo: any;
  close: string;
  fields: any[];
  fieldProperties: any[];
  gettingLookupValues: boolean;
  restrictJCCO: any; //Unassigned variable
  lookupValueSearch = new Subject<any[]>();
  lookupURL: string;
  lookupColumnName: string;
  preLoadLookup: boolean;
  itemIDString: any;
  sameEarnCode: boolean;
  firstEarnCode: any;
  fieldsLoaded: boolean;
  lineItemLoading: boolean;
  payAppOptions: any[];
  phaseChanged: boolean;
  canSave: boolean;
  selectFirstLookup: boolean;

  constructor(public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private employeeService: EmployeeService, public HttpClient: HttpClient, private eventService: EventService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {

    this.orderByPipe = new OrderByPipe();
    this.formData = {};
    if (this.portalSettings["CountryDateCode"].ConfigValue == "US") {
      this.format = "MM/DD/YYYY";
    }
    else {
      this.format = "DD/MM/YYYY";
    }

    this.exDisableLineRequireFields = this.portalSettings.ExDisableLineRequireFields.ConfigValue === "1";
    this.isPR = this.portalSettings.ExpensePostingType.ConfigValue.toLowerCase() === "p";
    this.lineTypeList = [];
    var lineTypeListCopy = {};
    var oriLineTypeList = {};
    oriLineTypeList["1"] = "Job";

    oriLineTypeList["3"] = "Expense";
    oriLineTypeList["4"] = "Equipment";
    oriLineTypeList["5"] = "EM Work Order";
    oriLineTypeList["8"] = "SM Work Order";

    this.portalSettings.ExpenseLineType.ConfigValue.split(",").forEach((val: string) => {
      if (oriLineTypeList.hasOwnProperty(val)) {
        this.lineTypeList.push({ index: parseInt(val), name: oriLineTypeList[val] });
        lineTypeListCopy[val] = true;
      }
    });

    if (lineTypeListCopy.hasOwnProperty(this.formData.LineChargeType))
      this.formData.LineChargeType = this.formData.LineChargeType === null ? this.lineTypeList[0].index : this.formData.LineChargeType;
    else {
      this.formData.LineChargeType = this.lineTypeList[0].index;
    }
    this.itemIDString = "";
    this.sameEarnCode = true;
    this.firstEarnCode = null;
    this.ExpenseItemID = null;
    this.data.forEach((val: any) => {
      if (val.Selected) {
        this.formData.ExpenseTransID = val.ExpenseTransID;
        this.itemIDString += val.ExpenseItemID + ",";
        if (!this.ExpenseItemID) {
          this.ExpenseItemID = val.ExpenseItemID;
        }
        if (this.firstEarnCode == null) {
          this.firstEarnCode = val.PRCo;
        }
        if (this.firstEarnCode != val.PRCo) {
          this.sameEarnCode = false;
        }
      }
    });
    this.itemDetails = {};
    this.itemDetailsCheck = {};
    this.lookupValues = {};
    this.lookupLoaded = [];
    this.typeSearch();
    this.typeChanged();
  }

  typeSearch() {
    this.lookupValueSearch
      .pipe(
        switchMap(lookupValueSearch => this.employeeService.getlookupURL(this.lookupURL))
      )
      .subscribe(data => {
        var response: any = data;
        if (this.preLoadLookup && response.length == 1)
          return this.setLookUps(this.lookupColumnName, true, response);
        else if (!this.preLoadLookup)
          return this.setLookUps(this.lookupColumnName, this.selectFirstLookup, response);
      });
  }

  callClearField() {
    this.clearField();
  }

  clearField() {
    for (let key in this.itemDetails) {
      this.itemDetails[key] = null;
    }
    this.formData.equipTempName = null;
    this.formData.jobTempName = null;
    this.formData.materialTempName = null;
    this.formData.smWorkOrderTempName = null;
    this.formData.woTempName = null;
    this.formData.equipTemp = null;
    this.formData.jobTemp = null;
    this.formData.materialTemp = null;
    this.formData.smWorkOrderTemp = null;
    this.formData.woTemp = null;
  }

  typeChanged() {
    this.clearField();
    this.getFieldsByLineItem();
  }


  getEarnCodes() {
    this.openModal();
    this.employeeService.getEarnCodes(this.firstEarnCode).then((response: any) => {
      this.earnCodeList = response;
      response.forEach((val: any) => {
        if (val.IsDefault)
          this.formData.SelectedEarnCode = val.EarnCode;
      })
      this.closeModal();
    });
  }

  getFieldsByLineItem() {
    this.openModal();
    this.employeeService.getFieldsByLineItem(this.formData.LineChargeType, null).then((response: any) => {
      this.fields = response;
      this.lookupValues = {};
      this.fieldProperties = [];
      this.itemDetailsCheck = {};
      this.fields.forEach((val: any) => {
        this.fieldProperties[val.ColumnName] = {};
        this.fieldProperties[val.ColumnName].Visible = true;
        this.fieldProperties[val.ColumnName].Required = val.Req;
        if (val.ColumnName == "UM")
          this.fieldProperties[val.ColumnName].Required = true;
        if (val.ColumnName != "Description" && !((val.ColumnName == "GLCo" || val.ColumnName == "GLAcct") && !this.formData.ExpenseTransID && this.isPR) &&
          !(val.ColumnName == "Material" && this.formData.LineChargeType != 2)) {
          this.itemDetailsCheck[val.ColumnName] = val.Req;
        }
        if (this.lookupValues[val.ColumnName] == null) {
          this.lookupValues[val.ColumnName] = [];
        }
      });
      if (this.formData.LineChargeType == 3 && !this.formData.ExpenseTransID && this.isPR) {
        this.fields.push({ FieldLabel: "EarnCode", ColumnName: "EarnCode", Req: "true", IsCombo: 1 });
        this.fieldProperties["EarnCode"] = {};
        this.fieldProperties["EarnCode"].Visible = true;
        this.fieldProperties["EarnCode"].Required = true;
        this.itemDetailsCheck["EarnCode"] = true;
        this.getEarnCodes();
      }
      this.groupFields();
      this.closeModal();
    });
  }

  earnCodeChanged() {
    this.willSave();
  }

  openModal() {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal() {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }

  groupFields() {
    this.fieldsName = [];
    this.groupedFields = [];
    var group = [];
    for (var i = 0; i < this.fields.length; i++) {
      if (group.length == 20) {
        this.groupedFields.push(group);
        group = [];
        if (this.fieldProperties[this.fields[i].ColumnName] != null) {
          if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
            group.push(this.fields[i]);
        }
      }
      else {
        if (this.fieldProperties[this.fields[i].ColumnName] != null) {
          if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
            group.push(this.fields[i]);
        }
      }
      if (this.fieldProperties[this.fields[i].ColumnName] != null) {
        if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
          this.fieldsName.push({ name: this.fields[i].ColumnName });
      }
    }
    if (group.length != 0) {
      this.groupedFields.push(group);
    }
    this.populateFields();
    this.fieldsLoaded = true;
    if (this.fieldsLoaded) {
      this.lineItemLoading = false;
    }
  }

  fieldChanged(field: any) {
    if (field.ColumnName === "JCCo") {
      this.formData.jobTemp = null;
      this.formData.jobTempName = null;
      this.formData.phaseTemp = null;
      this.formData.phaseTempName = null;
    }
    if (field.ColumnName === "EMCo") {
      this.formData.equipTemp = null;
      this.formData.equipTempName = null;
      this.formData.woTemp = null;
      this.formData.woTempName = null;
      this.comboFocused("EMCo");
    }
    if (field !== null) {
      switch (field.ColumnName) {
        case "ItemType":
          //this.getPOFields();
          break;
        case "JCCo":
          this.itemDetails.Job = null;
          this.lookupValues.Job = [];
          this.lookupLoaded.Job = false;
          this.itemDetails.Phase = null;
          this.lookupValues.Phase = [];
          this.lookupLoaded.Phase = false;
          this.formData.phaseTemp = null;
          this.formData.phaseTempName = null;
          this.itemDetails.JCCType = null;
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          this.formData.selectedPayApp = null;
          this.payAppOptions = [];
          this.comboFocused("Job");
          break;
        case "Equip":
          this.itemDetails.Equip = this.formData.equipTemp;
          break;

        case "Job":
          this.itemDetails.Job = this.formData.jobTemp;
          this.itemDetails.Phase = null;
          this.lookupValues.Phase = [];
          this.lookupLoaded.Phase = false;
          this.formData.phaseTemp = null;
          this.formData.phaseTempName = null;
          this.itemDetails.JCCType = null;
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          this.formData.selectedPayApp = null;
          //getPayAppOptions(true);
          break;
        case "Phase":
          this.phaseChanged = true;
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          if (!this.lookupValues.JCCType || this.lookupValues.JCCType.length === 0)
            this.itemDetails.JCCType = null;

          break;
        case "PO":
          this.phaseChanged = false;
          this.lookupLoaded["POItem"] = false;
          this.lookupValues["POItem"] = [];
          this.comboFocused("POItem", true);
          break;
        case "POItem":
          this.phaseChanged = false;
          break;

        case "EMCo":
          this.itemDetails.EMCType = null;
          this.lookupValues.EMCType = [];
          this.lookupLoaded.EMCType = false;
          this.itemDetails.WO = null;
          this.lookupValues.WO = [];
          this.formData.woTemp = null;
          this.lookupLoaded.WO = false;
          this.itemDetails.WOItem = null;
          this.lookupValues.WOItem = [];
          this.lookupLoaded.WOItem = false;
          this.itemDetails.Equipment = null;
          this.lookupValues.Equipment = [];
          this.lookupLoaded.Equipment = false;
          this.itemDetails.CostCode = null;
          this.lookupValues.CostCode = [];
          this.lookupLoaded.CostCode = false;
          break;
        case "WO":
          this.itemDetails.WO = this.formData.woTemp;
          this.itemDetails.WOItem = null;
          this.lookupValues.WOItem = [];
          this.lookupLoaded.WOItem = false;
          break;
        case "SMWorkOrder":
          this.itemDetails.SMWorkOrder = this.formData.smWorkOrderTemp;
          this.itemDetails.Scope = null;
          this.lookupValues.Scope = [];
          this.lookupLoaded.Scope = false;
          break;
        case "Material":
          this.itemDetails.Material = this.formData.materialTemp;
          this.itemDetails.UM = null;
          this.lookupValues.UM = [];
          this.lookupLoaded.UM = false;
          break;
        //SL fields
        case "SL":
          this.itemDetails.SLItem = null;
          this.lookupValues.SLItem = [];
          this.lookupLoaded.SLItem = false;
          break;
        case "SLItem":
        //this.getSLDefaults();
      }
    }
    this.willSave();
  };


  populateFields() {
    var savedData = {};
    this.fields.forEach((val: any) => {
      if (val.ColumnName !== "Description" && !((val.ColumnName === "GLCo" || val.ColumnName === "GLAcct") && this.isPR) &&
        !(val.ColumnName === "Material" && this.formData.LineChargeType !== 2)) {
        if (this.itemDetails[val.ColumnName]) {
          savedData[val.ColumnName] = this.itemDetails[val.ColumnName];
        }
        else {
          savedData[val.ColumnName] = null;
        }
        if (val.ColumnName === 'Equip') {
          this.formData.equipTemp = savedData[val.ColumnName];
          this.formData.equipTempname = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'Job') {
          this.formData.jobTemp = savedData[val.ColumnName];
          this.formData.jobTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'Material') {
          this.formData.materialTemp = savedData[val.ColumnName];
          this.formData.materialTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'SMWorkOrder') {
          this.formData.smWorkOrderTemp = savedData[val.ColumnName];
          this.formData.smWorkOrderTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'WO') {
          this.formData.woTemp = savedData[val.ColumnName];
          this.formData.woTempName = savedData[val.ColumnName];
        }
      }
    });
    //274187 - Ensure Empty data is not assigned for other Line Types
    if (Object.keys(savedData).length != 0) {
      this.itemDetails = savedData;
    }
    this.willSave();
    if (this.restrictJCCO) {
      this.fields.forEach((val: any) => {
        if ((val.ColumnName === "JCCo" || val.ColumnName === "GLCo"))
          this.loadValues(val.ColumnName, false, null);
      });
    }
  }

  willSave() {
    this.canSave = true;
    if (!this.exDisableLineRequireFields) {
      for (let item in this.itemDetailsCheck) {
        if (this.itemDetailsCheck[item] && !this.itemDetails[item]) {
          this.canSave = false;
        }
      }
    }
  }

  getLargeLookupValues(columnName: string, temp: any, tempName: any) {
    this.itemDetails[columnName] = this.formData[temp];
    if (this.formData[tempName] !== null && this.formData[tempName].length > 2) {
      this.loadValues(columnName, false, this.formData[tempName], true);
    }
    this.willSave();

    if (!this.canSave) {
      this.typeFields.form.invalid;
    }
  }

  setLookUps(columnName: string, selectFirst: boolean, response: any) {
    this.gettingLookupValues = false;
    this.lookupValues[columnName] = [];
    this.lookupValues[columnName] = response;
    //place null value for clearing
    if (this.exDisableLineRequireFields || !this.fieldProperties[columnName].Required)
      this.lookupValues[columnName].unshift({ DatabaseValue: null, DisplayValue: "No " + columnName });
    this.lookupLoaded[columnName] = true;
    if (selectFirst && this.lookupValues[columnName].length > 1) {
      this.itemDetails[columnName] = this.lookupValues[columnName][0].DatabaseValue;
      this.fieldChanged({ ColumnName: columnName });
    } else {
      if (columnName === "JCCo" || columnName === "GLCo") {
        var checkCount = 0;

        response.forEach((val: any) => {
          if ((parseInt(val.DatabaseValue) == this.itemDetails.JCCo && columnName == "JCCo") || (parseInt(val.DatabaseValue) == this.itemDetails.GLCo && columnName == "GLCo")) {
            this.itemDetails[columnName] = val.DatabaseValue;
            checkCount++;
          }
        });

        if (checkCount === 0) {
          if (this.exDisableLineRequireFields || !this.fieldProperties[columnName].Required) {
            if (this.lookupValues[columnName].length == 2) {
              this.itemDetails[columnName] = this.lookupValues[columnName][1].DatabaseValue;
            }
          } else {
            if (this.lookupValues[columnName].length == 1) {
              this.itemDetails[columnName] = this.lookupValues[columnName][0].DatabaseValue;
            }
          }
        }

      }
    }
  }


  loadValues(columnName: string, selectFirst?: boolean, searchText?: string, isSuper?: any, preload?: boolean) {
    this.gettingLookupValues = true;
    this.preLoadLookup = preload;
    this.lookupColumnName = columnName;
    this.selectFirstLookup = selectFirst;

    //var lineType = this.aPULKeyID == -1 ? this.lineType : lineItem.Type;
    this.lookupURL = "/employee/GetLookups?columnName="
      + columnName
      + "&lineType=" + this.formData.LineChargeType
      + (!this.itemDetails.JCCo || this.itemDetails.JCCo === undefined ? '' : "&jCCo=" + this.itemDetails.JCCo)
      + (!this.itemDetails.Job || this.itemDetails.Job === undefined ? '' : "&job=" + this.itemDetails.Job)
      + (!this.itemDetails.Phase || this.itemDetails.Phase === undefined ? '' : "&phase=" + this.itemDetails.Phase)
      + (!this.itemDetails.JCCType || this.itemDetails.JCCType === undefined ? '' : "&jCCType=" + this.itemDetails.JCCType)
      + (!this.itemDetails.Material || this.itemDetails.Material === undefined ? '' : "&material=" + this.itemDetails.Material)
      + (!this.itemDetails.Description || this.itemDetails.Description === undefined ? '' : "&description= " + encodeURIComponent(this.itemDetails.Description))
      + (!this.itemDetails.GLCo || this.itemDetails.GLCo === undefined ? '' : "&gLCo=" + this.itemDetails.GLCo)
      + (!this.itemDetails.INCo || this.itemDetails.INCo === undefined ? '' : "&iNCo=" + this.itemDetails.INCo)
      + (!this.itemDetails.EMCo || this.itemDetails.EMCo === undefined ? '' : "&eMCo=" + this.itemDetails.EMCo)
      + (!this.itemDetails.Equip || this.itemDetails.Equip === undefined ? '' : "&equip=" + this.itemDetails.Equip)
      + (!this.itemDetails.CompType || this.itemDetails.CompType === undefined ? '' : "&compType=" + this.itemDetails.CompType)
      + (!this.itemDetails.CostCode || this.itemDetails.CostCode === undefined ? '' : "&costCode=" + this.itemDetails.CostCode)
      + (!this.itemDetails.WO || this.itemDetails.WO === undefined ? '' : "&wO=" + this.itemDetails.WO)
      + (!this.itemDetails.WOItem || this.itemDetails.WOItem === undefined ? '' : "&wOItem=" + this.itemDetails.WOItem)
      + (!this.itemDetails.pOCo || this.itemDetails.pOCo === undefined ? '' : "&pOCo=" + this.itemDetails.POCo)
      + (!this.itemDetails.Loc || this.itemDetails.Loc === undefined ? '' : "&loc=" + this.itemDetails.Loc)
      + (!this.itemDetails.SMCo || this.itemDetails.SMCo === undefined ? '' : "&sMCo=" + this.itemDetails.SMCo)
      + (!this.itemDetails.SMWorkOrder || this.itemDetails.SMWorkOrder === undefined ? '' : "&sMWorkOrder=" + this.itemDetails.SMWorkOrder)
      + (!this.itemDetails.PO || this.itemDetails.PO === undefined ? '' : "&pO=" + this.itemDetails.PO)
      + (!this.itemDetails.POItem || this.itemDetails.POItem === undefined ? '' : "&pOItem=" + this.itemDetails.POItem)
      + (!this.itemDetails.POItemLine || this.itemDetails.POItemLine === undefined ? '' : "&pOItemLine=" + this.itemDetails.POItemLine)
      + (!this.itemDetails.SMScope || this.itemDetails.SMScope === undefined ? '' : "&sMScope=" + this.itemDetails.SMScope)
      + "&userKeyID=" + (this.selectedEmployee === null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID)
      + "&expenseItemId=" + this.ExpenseItemID;

    if (searchText !== null && searchText !== undefined) {
      this.lookupURL += "&searchText=" + searchText;
    }

    if (isSuper && isSuper !== undefined) {
      this.lookupValueSearch.next();
    }
    else {
      this.lookupValueSearch.next();
    }
  }

  comboFocused(columnName: string, selectFirst?: boolean) {
    if ((this.lookupValues[columnName] === null || this.lookupValues[columnName] === undefined || this.lookupValues[columnName].length === 0)) {
      this.loadValues(columnName, selectFirst, null, null, null);
    }
  }


  saveClicked() {
    this.employeeService.bulkEditItems(this.itemIDString, null,
      this.itemDetails.JCCo,
      this.itemDetails.Job,
      this.itemDetails.Phase,
      this.itemDetails.GLCo,
      this.itemDetails.GLAcct,
      this.itemDetails.SMCo,
      this.itemDetails.SMWorkOrder,
      this.itemDetails.EMCo,
      null,
      this.itemDetails.JCCType,
      this.itemDetails.SL,
      this.itemDetails.SLItem,
      this.itemDetails.WO,
      this.itemDetails.WOItem,
      this.itemDetails.Equip,
      this.itemDetails.CostCode,
      this.itemDetails.EMCType,
      this.itemDetails.CompType,
      this.itemDetails.Component,
      this.itemDetails.INCo,
      this.itemDetails.Loc,
      this.itemDetails.Material,
      this.itemDetails.Scope,
      this.itemDetails.POItemLine,
      this.itemDetails.SMCostType,
      this.formData.LineChargeType,
      (this.selectedEmployee === null ? null : this.selectedEmployee.UserKeyID),
      this.itemDetails.EarnCode).then((response: any) => {
        this.activeModal.close('close');
      });
    this.activeModal.close('close');
  }

  cancelClicked() {
    this.activeModal.close();
  }

}
